import { UnderlineTag } from './UnderlineTag';

export type { TypeUnderlineTagProps } from './types';
export default UnderlineTag;
